import React from "react";

export default class KYCQuestion extends React.Component
{
	fieldName = "";

	_onOptionsListChange = ({type, name}, option, index) =>
	{
		const newOptions = [...this.state.fields[name].options].map((o, i) =>
		{
			if (i === index)
			{
				return option;
			}
			else
			{
				return {...o, checked: type === "radio" ? false : o.checked};
			}
		});

		this.setState({
			fields: {
				...this.state.fields,
				[name]: {
					options: newOptions
				}
			}
		}, () => {
			if (this.props.onUpdate)
			{
				let fulfilled = false;
				for (let i = 0; i < this.state.fields[this.fieldName].options.length; i++)
				{
					if (this.state.fields[this.fieldName].options[i].checked)
					{
						fulfilled = true;
					}
				}
				this.props.onUpdate(fulfilled);
			}
		});
	};
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/KYCQuestion.js